import Modal from 'components/Layout/Modal';
import Button from 'components/form/Button';

const RequestVerificationModal = ({
  handleConfirmation,
  onHide,
  title,
  isLoading = false,
}) => {
  return (
    <Modal onHide={onHide} size="md">
      <div>
        <div className="text-18-400 text-center">Are you sure ?</div>

        <div className="cmt-24 cmb-29 text-center text-14-300-18">{title} </div>

        <div className="d-flex justify-content-center gap-4">
          <Button
            text="Yes, confirm"
            btnStyle="primary-dark"
            className="cps-20 cpe-20 h-35"
            onClick={handleConfirmation}
            type="submit"
            btnLoading={isLoading}
            disabled={isLoading}
          />
          <Button
            text="Cancel"
            btnStyle="light-outline"
            className="cps-20 cpe-20 h-35"
            onClick={onHide}
            disabled={isLoading}
          />
        </div>
      </div>
    </Modal>
  );
};

export default RequestVerificationModal;
